export const INITIAL_STATE = {
    tags: [],
    getTagsIsLoading: false,
    getTagsErrors: null,
}